<template>
	<div class="container">
		<div class="main_box">
			<!--块1-->
			<div class="block_1">
				<div class="block_1_main">
					<div class="logo">
						<img src="../../assets/img_public/logo.png" />
					</div>
					<div class="nav_box">
						<div style="padding: 16px 0 16px 0;border-bottom: 1px solid #E3E1E6;font-size: 16px;font-weight: bold;" @click="goIndex">首页</div>
						<van-collapse v-model="activeName" accordion>
							<van-collapse-item
								v-for="(value, index) in navData"
								:key="index"
								:name="value.title"
								:border="false"
							>
								<template #right-icon>
									<van-icon :name="activeName == value.title ? 'minus' : 'plus'" size="16px" color="#999999" />
								</template>
								<template #title>
									<div class="title">{{ value.title }}</div>
								</template>
								<div v-if="value.title != $t('footer.text7')">
									<div v-for="(value2, index2) in value.children" :key="index2" class="text" @click="oneNavClick(value2, true)">{{ value2.title }}</div>
								</div>
								<div v-else>
									<div v-for="(value2, index2) in value.children.cate_list" :key="index2" class="text" @click="oneNavClick2">{{ value2.title }}</div>
								</div>
							</van-collapse-item>
						</van-collapse>
					</div>
					<div v-if="lang == 'cn'" class="code_box">
						<div class="code_el" style="position: relative;top: -8px;">
							<img src="../../assets/img_public/icon_code_3.png" style="width: 118px;" />
							<div class="tit" style="padding-top: 0;">库尔科技</div>
						</div>
						<div class="code_el">
							<img src="../../assets/img_public/icon_code_2.webp" />
							<div class="tit">库尔医疗精灵</div>
						</div>
						<div class="code_el">
							<img src="../../assets/img_public/icon_code_1.webp" />
							<div class="tit">库尔先锋</div>
						</div>
					</div>
					<div class="msg_box">
						<div class="msg_el" style="display: flex;font-size: 16px;">
							<van-icon name="phone-o" size="18px" style="top: 4px;" />
							<div style="flex: 1;padding-left: 4px;">
								OTC/线上新零售渠道:&nbsp;
								<a href="tel:4006061166">400 606 1166</a>&ensp;|&ensp;<a href="tel:010-69391166">010-69391166</a>
							</div>
						</div>
						<div class="msg_el" style="font-size: 16px;">
							<van-icon name="phone-o" size="18px" style="top: 4px;" />&nbsp;非OTC渠道:&nbsp;
							<a href="tel:010-69390623">010-69390623</a>
							<!-- &ensp;|&ensp;<a href="tel:0312-6779810">0312-6779810</a> -->
						</div>
						<div class="msg_el" style="margin-bottom: 16px;font-size: 16px;">
							<van-icon name="envelop-o" size="18px" style="top: 4px;" />&nbsp;
							<a href="mailto:liang@cordx.com">liang@cordx.com</a>
						</div>
						<div class="msg_el">
							{{ $t('footer.text1') }}<span style="font-size: 16px;">5900 Windward Pkwy. Alpharetta, GA 30005 USA</span>
						</div>
						<div class="msg_el">
							{{ $t('footer.text2') }}
						</div>
						<div class="msg_el">
							{{ $t('footer.text3') }}
						</div>
					</div>
					<div class="web_box">
						<div class="tit">{{ $t('footer.text4') }}</div>
						<div class="web_main">
							<div class="web_el">
								<a href="https://cordx.com/">
									<img src="../../assets/img_public/link_7.png" />
								</a>
							</div>
							<div class="web_el">
								<a href="https://abiores.com.cn">
									<img src="../../assets/img_public/web_2.png" />
								</a>
							</div>
							<div class="web_el">
								<a href="https://m.bonore.com/">
									<img src="../../assets/img_public/bonore.png" />
								</a>
							</div>
							<div class="web_el" style="position: relative;left: 5px;">
								<a href="https://ucreagent.com/">
									<img src="../../assets/img_public/ucreagent.png" />
								</a>
							</div>
							<div class="web_el">
								<a href="https://cupet.com/">
									<img src="../../assets/img_public/web_5.png" />
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2">
				<div class="tit">
					{{ $t('footer.text5') }}
				</div>
				<div class="tit">
					<a href="https://beian.miit.gov.cn/">京ICP备18005116号-2</a>&ensp;|&ensp;<a href="https://beian.mps.gov.cn/#/query/webSearch">公安备案号：11011102001223</a>
				</div>
				<div class="tit">
					<a href="https://backapi.coretests.com/vancheerfile/Images/2022-00222.jpg">药品医疗器械网络信息服务备案编号：<br />（京）网药械信息备字（2022）第00222号</a>
				</div>
			</div>
			<!--块2-->
		</div>
	</div>
</template>

<script>
export default {
	components:{
		//
	},
	data() {
		return {
			lang: sessionStorage.getItem('lang'),
			navData: [],
			activeName: ''
			
		}
	},
	created(){
		let that = this;
		if(sessionStorage.getItem('navList')) {
			let data = JSON.parse(sessionStorage.getItem('navList'));
			data.forEach((value, index) => {
				if(value.title != that.$t('footer.text6')) {
					that.navData.push(value);
				}
			});
		}
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		//跳转首页
		goIndex() {
			let that = this;
			if(that.$route.path != '/') {
				that.$router.push({ path: '/', });
			}else {
				window.location.reload();
			}
		},
		oneNavClick2() {
			if(this.$route.path != '/product-list.html') {
				this.$router.push({ path: '/product-list.html' });
				setTimeout(() => {
					window.location.reload();
				}, 300);
			}
		},
		//一级导航点击
		oneNavClick(value, value2) {
			let that = this;
			if(that.$route.path != value.url) {
				that.isShow = false;
				if(value.route == 'JobList') {
					if(that.$route.name === value.route) {
						that.$router.push({ path: '/job/'+value.url });
						window.location.reload();
					}else {
						that.$router.push({ path: '/job/'+value.url });
					}
				}else {
					if(value2) {
						if(that.$route.name === value.route) {
							that.$router.push({ path: value.url, });
							window.location.reload();
						}else {
							if(that.$route.path != value.url) {
								that.$router.push({ path: value.url, });
								setTimeout(() => {
									window.location.reload();
								}, 300);
							}
						}
					}else {
						that.$router.push({ path: value.url });
					}
				}
			}else {
				window.location.reload();
			}
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	//块2
	.block_2{
		padding: 16px 0;
		text-align: center;
		background-color: #F7F6F9;
		.tit{
			padding: 4px 0;
			font-size: 12px;
		}
		a{
			color: #000000;
		}
	}
	//块1
	.block_1{
		.block_1_main{
			padding: 40px 20px 30px 20px;
			border-top: 1px solid #999999;
			.web_box{
				.web_main{
					display: flex;
					align-items: end;
					.web_el{
						flex: 1;
						padding: 0 3px;
						img{
							width: 100%;
						}
						a{
							display: inline-block;
							height: 100%;
						}
					}
				}
				.tit{
					padding: 20px 0 10px 0;
					text-align: center;
				}
			}
			.msg_box{
				.msg_el{
					margin-bottom: 5px;
					a{
						color: #000000;
					}
				}
			}
			.code_box{
				display: flex;
				padding: 40px 0;
				.code_el{
					flex: 1;
					text-align: center;
					.tit{
						padding-top: 8px;
						font-size: 12px;
					}
					img{
						width: 100px;
					}
				}
			}
			.nav_box{
				.van-collapse{
					padding: 10px 0 0 0;
					.van-collapse-item{
						padding: 16px 0 0 0;
						border-bottom: 1px solid #E3E1E6;
					}
				}
				.title{
					padding-bottom: 18px;
					font-size: 16px;
					font-weight: bold;
				}
				.text{
					padding-bottom: 15px;
					font-size: 16px;
					color: #666666;
				}
			}
			.logo{
				padding-bottom: 6px;
				img{
					width: 110px;
				}
			}
		}
	}
}
</style>
<style scoped>
>>> .nav_box .van-hairline--top-bottom::after, >>> .nav_box .van-hairline-unset--top-bottom::after{
	border: none;
}
>>> .nav_box .van-cell, >>> .nav_box .van-collapse-item__content{
	padding: 0;
}
>>> .nav_box .van-cell--clickable{
	background-color: transparent;
}
</style>